import { createContext, useContext, useState } from "react";

export const DEMO_USERS = [
  { id: "demo-andini", name: "Andini Prameswari", city: "Jakarta", label: "Profil Andini (Relawan Berpengalaman)" },
  { id: "demo-baru", name: "Relawan Baru", city: "Jakarta", label: "Akun Relawan Baru" },
  { id: "demo-koordinator", name: "Koordinator Komunitas", city: "Bandung", label: "Akun Koordinator Komunitas" },
];

const STORAGE_KEY = "bn.activeUser";
const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUserState] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || DEMO_USERS[0];
    } catch {
      return DEMO_USERS[0];
    }
  });

  const setUser = (u) => {
    setUserState(u);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(u));
  };

  return <AuthContext.Provider value={{ user, setUser }}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);
